import React from "react";
import ContactHeader from "../components/contact/ContactHeader";
import ContactForm from "../components/contact/ContactForm";

const ContactMain = () => {
  return (
    <div data-new-gr-c-s-check-loaded="14.1231.0" data-gr-ext-installed>
      <ContactHeader />
      <ContactForm />
    </div>
  );
};

export default ContactMain;
